@use '@/styles/variables' as *;

// ─── Wrapper ──────────────────────────────────────────────────────────────────

.blog {
  width: 100%;
  max-width: 860px;
  margin: 0 auto;
}

// ─── List ─────────────────────────────────────────────────────────────────────

.list {
  list-style: none;
  padding: 0;
  margin: 0;
  border-top: 1px solid var(--border);
}

// ─── Item ─────────────────────────────────────────────────────────────────────

.item {
  opacity: 0;
  transform: translateY(16px);
  transition:
    opacity 0.45s ease,
    transform 0.45s ease;
  border-bottom: 1px solid var(--border);

  &.visible {
    opacity: 1;
    transform: translateY(0);
  }
}

// ─── Row (button) ─────────────────────────────────────────────────────────────

.row {
  width: 100%;
  background: none;
  border: none;
  padding: 2rem 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  text-align: left;
  cursor: pointer;
  color: inherit;
  font: inherit;
  transition: opacity 0.2s ease;

  &:hover .title {
    color: var(--forest);
  }

  &:hover .readLink {
    gap: 0.45rem;
  }

  &:focus-visible {
    outline: 2px solid var(--foreground);
    outline-offset: 4px;
    border-radius: var(--radius);
  }
}

// ─── Meta bar ─────────────────────────────────────────────────────────────────

.metaBar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.metaLeft {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.category {
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 0.2rem 0.6rem;
  border-radius: 999px;
  background: color-mix(in srgb, var(--forest) 10%, var(--background));
  color: var(--forest);
  border: 1px solid color-mix(in srgb, var(--forest) 22%, transparent);
}

.date {
  font-size: 0.82rem;
  color: var(--muted-foreground);
}

.readTime {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.82rem;
  color: var(--muted-foreground);
}

.readLink {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.82rem;
  font-weight: 500;
  color: var(--muted-foreground);
  white-space: nowrap;
  transition: gap 0.2s ease;
}

.likes {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.82rem;
  color: var(--muted-foreground);
}

// ─── Content ──────────────────────────────────────────────────────────────────

.title {
  font-size: clamp(1.05rem, 2.2vw, 1.45rem);
  font-weight: 600;
  font-family: var(--font-display);
  letter-spacing: -0.02em;
  color: var(--foreground);
  line-height: 1.3;
  max-width: 68ch;
  text-wrap: balance;
  transition: color 0.2s ease;
}

.excerpt {
  font-size: 0.9rem;
  color: var(--muted-foreground);
  line-height: 1.7;
  max-width: 60ch;
}

// ─── Load more ────────────────────────────────────────────────────────────────

.loadMoreWrapper {
  display: flex;
  justify-content: center;
  padding-top: 2.5rem;
}

.loadMoreBtn {
  background: none;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 0.65rem 1.75rem;
  font: inherit;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--muted-foreground);
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    color 0.2s ease;

  &:hover {
    border-color: var(--forest);
    color: var(--forest);
  }

  &:focus-visible {
    outline: 2px solid var(--foreground);
    outline-offset: 3px;
  }
}

// ─── Responsive ───────────────────────────────────────────────────────────────

@media (max-width: #{$breakpoint-sm}) {
  .row {
    padding: 1.5rem 0;
    gap: 0.6rem;
  }

  .readLink {
    display: none;
  }
}

// ─── Reduced motion ───────────────────────────────────────────────────────────

@media (prefers-reduced-motion: reduce) {
  .item {
    opacity: 1;
    transform: none;
    transition: none;
  }
}
